import axios from 'axios'
import library from '../../../utils/Library'

export const helpGetTypesOrganization = async (token = null) => {
  const TOKEN = token || sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('organization') + '/getOrganizationTypeCorpEntities'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
